import { render, staticRenderFns } from "./TaskViewDateDispatcher.vue?vue&type=template&id=4bd509be&scoped=true&lang=pug&"
import script from "./TaskViewDateDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewDateDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd509be",
  null
  
)

export default component.exports